import { Form } from "react-bootstrap";

const CheckboxRangeFilterType = ({
  title,
  checkboxList,
  onFilterChange,
  isRadio
}) => {
  return (
    <div>
      <div className="f-12 f-500 f-darkgrey">
        {title}
      </div>
      <div className={`p-1 ${isRadio ? "d-flex flex-column gap-4" : ""}`}>
        {checkboxList?.map(
          (checkbox, checkboxIndex) => {
            return (
              <div 
                key={`checkbox-${checkbox?.key}`}
                className="d-flex align-items-center"
              >
                <div>
                  <Form.Group
                    controlId={`card ${checkbox?.key}`}
                    className={` ${isRadio ? "radio-shadow" : "mb-3 round-checkbox blue-checkbox checkboxstyle"}`}
                  >
                    <Form.Check
                      type={isRadio ? "radio" : "checkbox"}
                      name={
                        'checkbox-group'
                      }
                      label=""
                      disabled={false}
                      onClick={(e) => {
                        if (isRadio && checkbox?.value) return;
                        const updatedList = [...checkboxList].map((check, index) => {
                          if (checkboxIndex === index) {
                            return {
                              ...check,
                              value: !check.value
                            };
                          } else if (isRadio) {
                            return {
                              ...check,
                              value: false
                            };
                          }
                          return check;
                        });
                        onFilterChange(updatedList);
                      }}
                      id={`checkbox-${checkbox?.key}`}
                      checked={checkbox?.value}
                    />
                  </Form.Group>
                </div>
                <label 
                  htmlFor={`checkbox-${checkbox?.key}`} 
                  className={`f-500 ${isRadio ? "" : "pl-2 pt-2"} m-0`} 
                  style={{ whiteSpace: 'nowrap' }}
                >
                  {checkbox.label}
                </label>
              </div>
            );
          }
        )}
      </div>
    </div>
  );
}

export default CheckboxRangeFilterType;
